export enum cardType {
  system = 1,
  thirdapp = 2
}

export enum cardDeletable {
  no = 0,
  yes = 1
}

export enum cardStickied {
  no = 0,
  yes = 1
}

export enum cardScenes {
  application = 1,
  scenes = 2
}

export enum cardHostType {
  mobile = 1,
  pc = 2
}

export interface ICard {
  appId: string; // 宿主应用ID
  applicationDto: any; // 关联的三方应用信息
  applicationId: string; // 关联的三方应用ID
  cardId: string; // 卡片ID
  contentDeeplink: string; // 渲染卡片内容的deeplink,与卡片类型一致
  contentHeight: number; // 卡片高度
  defaultAdded: number; // 默认添加
  deletable: cardDeletable; // 是否可删除 1 可删除 0 不可删除
  descDeeplink: string; // 查看详情deeplink
  description: string; // 卡片右上角详情内容
  hostAppMaxVersion: string; // 宿主应用最大版本号
  hostAppMinVersion: string; // 宿主应用最小版本号
  hostType: cardHostType; // 终端类型：1 移动端   2 非移动端
  icon: string; // 卡片logo
  name: string; // 卡片名称
  scenes: cardScenes[]; // 卡片使用场景 1 应用是应用中心，卡片是个人工作台 2 专班
  status: any; // 状态
  stickied: cardStickied; // 是否置顶 1 置顶  0 不置顶
  titleType: number; // 卡片标题类型
  type: cardType; // 卡片类型 1 系统原生卡片 2 第三方卡片
}

export interface ICardRes {
  addedCards: ICard[];
  remainingCards: ICard[];
}

export type stillVoid = void | never;
